import React from 'react';
import {twMerge} from 'tailwind-merge';

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
    className?: string;
}

interface ParagraphProps extends React.HTMLAttributes<HTMLParagraphElement> {
    className?: string;
}
const H1: React.FC<React.PropsWithChildren<HeadingProps>> = ({children, className}) => {
    return <h1 className={twMerge('text-black text-3xl font-black', className)}>{children}</h1>;
};

const H2: React.FC<React.PropsWithChildren<HeadingProps>> = ({children, className}) => {
    return <h2 className={twMerge('text-black text-2xl font-bold', className)}>{children}</h2>;
};

const H3: React.FC<React.PropsWithChildren<HeadingProps>> = ({children, className}) => {
    return <h3 className={twMerge('text-black text-xl font-semibold', className)}>{children}</h3>;
};

const H4: React.FC<React.PropsWithChildren<HeadingProps>> = ({children, className}) => {
    return <h4 className={twMerge('text-black text-lg font-semibold', className)}>{children}</h4>;
};

const H5: React.FC<React.PropsWithChildren<HeadingProps>> = ({children, className}) => {
    return <h5 className={twMerge('text-black text-base font-semibold', className)}>{children}</h5>;
};

const H6: React.FC<React.PropsWithChildren<HeadingProps>> = ({children, className}) => {
    return <h6 className={twMerge('text-black text-base font-medium', className)}>{children}</h6>;
};

const P: React.FC<React.PropsWithChildren<ParagraphProps>> = ({children, className}) => {
    return <p className={twMerge('text-neutral-700 text-[13px] font-normal', className)}>{children}</p>;
};

export const Typography = {H1, H2, H3, H4, H5, H6, P};
